import { render } from "./IconLabel.vue?vue&type=template&id=f27902c2&scoped=true"
import script from "./IconLabel.vue?vue&type=script&lang=js"
export * from "./IconLabel.vue?vue&type=script&lang=js"

import "./IconLabel.vue?vue&type=style&index=0&id=f27902c2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27902c2"]])

export default __exports__